import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import getColorCode from 'src/utils/GetThemeColor';
import { ReactComponent as Refresh } from 'src/Images/icons/common/refresh.svg';
import { ReactComponent as Search } from 'src/Images/icons/common/search.svg';
import { ReactComponent as Create } from 'src/Images/icons/common/create.svg';
import { CustomToolTip } from 'src/utils/CustomToolTip';
import TableContent from 'src/pages/Settings/Enterprise/Dimensions/DimensionListTable/TableContent';
import { getDimensionList } from 'src/redux/Actions/VehicleTracking';
import Table from 'src/components/PendingGrnVehicleEntry/List/Table';
import { useNavigate, useLocation } from 'react-router-dom';
import usePageTitle from 'src/utils/SetPageTitle';
import Breadcrumb from 'src/components/Breadcrumb';
import { useSetBreadcrumbData } from 'src/utils/SetBreadcrumbData';

export default function DimensionList() {
  usePageTitle('Cloud VT • Dimensions');
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const tenantOrganisationId = authReducer.userData.organisations?.id;
  const [tableSortOrder, setTableSortOrder] = useState(null);
  const [searchInput, setSearchInput] = useState('');

  useEffect(() => {
    dispatch(getDimensionList(tenantOrganisationId, ''));
  }, [dispatch, tenantOrganisationId]);

  // Handle search input changes with debouncing
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (tenantOrganisationId) {
        dispatch(getDimensionList(tenantOrganisationId, searchInput || ''));
      }
    }, 500); // 500ms debounce delay

    return () => clearTimeout(timeoutId);
  }, [searchInput, dispatch, tenantOrganisationId]);

  const tableHeaders = [
    {
      label: 'Title',
      value: 'name',
    },
    {
      label: 'Type',
      value: 'data_type',
    },
    {
      label: 'Unit of measurement',
      value: 'unit_measurement',
    },
    {
      label: 'Description',
      value: 'description',
    },
  ];
  const [dimensionSearchTerm, setDimensionSearchTerm] = useState(null);
  const searchTexts = ['Name'];

  useEffect(() => {
    const interval = setInterval(() => {
      setDimensionSearchTerm(
        (prev) =>
          searchTexts[(searchTexts.indexOf(prev) + 1) % searchTexts.length],
      );
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const handleTableSortOrder = (value) => {
    setTableSortOrder(value);
  };

  const handleSearchInput = (e) => {
    const { value } = e.target;
    setSearchInput(value);
  };

  useSetBreadcrumbData(location.pathname, 'Dimensions');

  return (
    <div className="page-layout div-flex-column">
      <div className="div-space-between left-padding">
        <div className="div-flex-row cg-5">
          <Breadcrumb />
        </div>
        <Col xxl={2} xl={2} lg={2} className="p-0 m-0">
          <div className="input-wrapper">
            <input
              type="text"
              className="form-input-section input-icon-remove"
              placeholder={`Search by ${dimensionSearchTerm}`}
              value={searchInput || ''}
              onChange={handleSearchInput}
            />
            <span className="form-input-section-icon">
              <Search
                className="icon-size-lg"
                color={getColorCode(themeColor)}
              />
            </span>
          </div>
        </Col>
      </div>
      <div className="div-space-between border-bottom slider-padding">
        <span className="text-xxl text-bold left-padding">Dimensions</span>
        <div className="div-flex-row div-align-center cg-20 right-padding">
          <div className="div-flex-row cg-20 div-align-center">
            <CustomToolTip title="Refresh" placement="bottom">
              <button
                aria-label="Refresh"
                className="icon-btn-none"
                onClick={() => {
                  dispatch(
                    getDimensionList(tenantOrganisationId, searchInput || ''),
                  );
                }}
              >
                <Refresh className="icon-size-lg" color="#9F9F9F" />
              </button>
            </CustomToolTip>
          </div>
        </div>
      </div>

      <Table
        headers={tableHeaders}
        minCellWidth={150}
        tableContent={<TableContent headers={tableHeaders} />}
        tableSortOrder={tableSortOrder}
        handleTableSortOrder={handleTableSortOrder}
      />
      <div className="footer-container left-padding">
        <div className="div-flex-row div-flex-end div-align-center footer-content-for-page">
          <button
            aria-label="button"
            className={`create-icon-btn theme-background-${themeColor}`}
            onClick={() => navigate('/dimensions/new/')}
          >
            <Create className="icon-size-lg" color="#FFFFFF" />
          </button>
        </div>
      </div>
    </div>
  );
}
